import * as React from 'react';
import { formStyles } from 'styles/formStyles';
import { Timestamp, TimestampType } from './Timestamp';

interface TimestampProps {
    createdDate?: string;
    createdDecimalTime?: number;
    createdUser?: string;
    modifiedDate?: string;
    modifiedDecimalTime?: number;
    modifiedUser?: string;
    showCreated?: boolean;
}

export const Timestamps: React.FC<TimestampProps> = ({
    createdDate,
    createdDecimalTime,
    createdUser,
    modifiedDate,
    modifiedDecimalTime,
    modifiedUser,
    showCreated = true,
}) => {
    return (
        <div className={formStyles.twoColumnsBlock}>
            <div className={formStyles.timestampLeft}>
                {showCreated && (
                    <Timestamp
                        date={createdDate}
                        decimalTime={createdDecimalTime}
                        user={createdUser}
                        type={TimestampType.created}
                    />
                )}
            </div>
            <div className={formStyles.timestampRight}>
                <Timestamp
                    date={modifiedDate}
                    decimalTime={modifiedDecimalTime}
                    user={modifiedUser}
                    type={TimestampType.modified}
                />
            </div>
        </div>
    );
};
